function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useCallback, useEffect, useRef, useState } from 'react';
import { classnames, guid } from '@okee-uikit/react-utils';
import { usePrefixCls } from '@okee-uikit/react-config';
import { useUpload } from '..';
export function RcTrigger(props) {
  var children = props.children,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      _props$multiple = props.multiple,
      multiple = _props$multiple === void 0 ? false : _props$multiple,
      _props$className = props.className,
      className = _props$className === void 0 ? '' : _props$className,
      _props$accept = props.accept,
      accept = _props$accept === void 0 ? '*/*' : _props$accept;

  var _useState = useState(guid),
      _useState2 = _slicedToArray(_useState, 2),
      key = _useState2[0],
      setKey = _useState2[1];

  var fileUpload = useUpload();
  var inputRef = useRef(null);
  var cls = classnames(usePrefixCls('upload-trigger', {
    disabled: disabled
  }), className);
  var onClick = useCallback(function () {
    if (!disabled) {
      fileUpload.clickInput();
    }
  }, [disabled]);
  var onFileChange = useCallback(function (ev) {
    if (ev === null || ev === void 0 ? void 0 : ev.target.files) {
      fileUpload.addFiles(ev.target.files);
      setKey(guid());
    }
  }, []);
  useEffect(function () {
    fileUpload.init(inputRef);
  }, []);

  var _children = typeof children === 'function' ? children({
    disabled: disabled
  }) : children;

  return React.createElement("span", {
    className: cls
  }, React.createElement("label", {
    onClick: onClick
  }, _children), React.createElement("input", {
    type: "file",
    key: key,
    ref: inputRef,
    style: {
      display: 'none'
    },
    onChange: onFileChange,
    multiple: multiple,
    accept: accept
  }));
}